<script>
import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import moveTextHover from '@/components/moveTextHover';
import shareBtn from '@/components/shareBtn';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.NOTFOUND,
  components: {
    commonFooter,
    commonNav,
    moveTextHover,
    shareBtn,
  },
  data() {
    return {
      ready: false,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
    };
  },
  created() {
    setMetaUtil.setMeta(this, document,
      `${this.$i18n.messages.ja.message.notFound.pageName} - ${this.$i18n.messages.ja.message.bandName}`,
      this.$i18n.messages.ja.message.notFound.description,
    );
    document.dispatchEvent(new Event('custom-render-trigger'));

    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    moveToIndex() {
      this.$router.push({ name: Constants.ROUTER.INDEX });
    },
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  }
};
</script>

<template>
  <div class="view-404 page" :class="ready ? 'is-ready' : ''">
    <common-nav/>
    <div id="contents-main" :style="{height: windowHeight + 'px'}">
      <div class="text wf-gothicfont">{{$t('message.notFound.pageName')}}</div>
      <div class="return" @click="moveToIndex">
        <move-text-hover :target-text="$t('message.notFound.returnToHome')" />
      </div>
    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      padding-top: $commonNavHeight;
      padding-top: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;
      .text {
        font-size: 2em;
      }
      .return {
        font-size: 0.8em;
        cursor: pointer;
        &:hover {
          color: $accentColor2;
        }
      }
    }
  }
</style>
